export const getCardContentArray = contentSring => {

  const parser = new DOMParser();
  const doc = parser.parseFromString(contentSring, "text/html");
  let domElements = [...(doc.querySelector("div") ? doc.querySelector("div").querySelectorAll("h1,h2,h3,h4,p") : [])];

  const h1Index = domElements.findIndex(item => item.nodeName == "H1") > -1 ? domElements.findIndex(item => item.nodeName == "H1") : 0;
  const articleTitle = domElements[h1Index].textContent;
  domElements.splice(h1Index, 1);

  const secondIndex =
    domElements.findIndex(item => item.nodeName == "H1") > -1
      ? domElements.findIndex(item => item.nodeName == "H1")
      : domElements.findIndex(item => item.nodeName == "H2") > -1
        ? domElements.findIndex(item => item.nodeName == "H2")
        : -1 ;
  const secondTitle = secondIndex > -1 ? domElements[secondIndex].textContent : null;
  secondTitle && domElements.splice(secondIndex, 1);

  const descIndex = domElements.findIndex(item => item.nodeName == "P") > -1 ? domElements.findIndex(item => item.nodeName == "P") : 0;
  const description = domElements[descIndex].textContent;

  return { title: articleTitle, secondTitle, description };
};
export const getCardContentArrayMarkup = contentSring => {
  const separators = ["##", "\n\n"];
  const pattern = new RegExp(separators.join("|"), "g");
  const newMarkdown = contentSring.split(pattern).filter(el => el !== "" && el.substring(0, 2) !== "![");

  const secondTitleIndex = newMarkdown.findIndex((el, indx) => el.length <= 60 && indx !== 0);
  const descriptionIndex = newMarkdown.findIndex((el, indx) => el.length >= 50 && indx !== 0);

  return { title: newMarkdown[0].split("!")[0], secondTitle: newMarkdown[secondTitleIndex], description: newMarkdown[descriptionIndex] };
};

export const attachSizeToImage = (img, size) => {
  const url = new URL(img);
  url.pathname = `/${size}${url.pathname}`;
  return url.toString();
};

export const addCdnImageToArticle = (data, cdnImage, existingUsedImages = []) => {
  const noImageUrl = "https://cdn2.airfind.com/news-noimage.jpg";
  const usedImages = new Set(existingUsedImages);

  return data.map(article => {
    const mainCategory = extractFirstSegment(article.category);
    let notUsedImage = cdnImage || article.images?.find(img => !usedImages.has(img)) || noImageUrl;
    usedImages.add(notUsedImage);
    if (window.host) notUsedImage = notUsedImage.replace('airfind.com', window.host)

    return {
      ...article,
      cdnImage: notUsedImage,
      mainCategory: mainCategory
    };
  });
};


export const getNextUniqueImage = (images, imageSet) => {
  for (let img of images) {
    if (!imageSet.has(img)) {
      imageSet.add(img);
      return img;
    }
  }
  return null; // In case all images are used
};

export const extractFirstSegment = inputString => {
  if (inputString?.startsWith("/")) {
    const segments = inputString.split("/").filter(segment => segment.trim() !== "");
    return segments.length > 0 ? segments[0] : "";
  } else {
    return "";
  }
};
export const addSlugToObjects = (array) => {
  return array.map(obj => ({
    ...obj,
    slug: (obj.keyword || obj.searchTerm).replace(/\s+/g, '-')
  }));
};
